import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Router } from "../Helpers";
import ExcursionItem from "../ExcursionItem";
import Slider from "react-slick";
import _ from "lodash";
import { param } from "jquery";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tours: this.props.data.tours.data,
      visitorTours: this.props.data.tours.data.filter((tour) =>
        tour.tags.data.find((tag) => tag.name == "Visitors")
      ),
      localTours: this.props.data.tours.data.filter((tour) =>
        tour.tags.data.find((tag) => tag.name == "Locals")
      ),
    };
  }

  generateProductUrl(tour) {
    // console.log("props", this.props.data);
    const { active_site, location, routes } = this.props.data;
    const router = Router(routes);

    let params = {
        domain: active_site.domain,
        id: tour.id,
        tour_slug: tour.slug,
    };

    if(_.isEmpty(location)){
      params.id = tour.id;
      params.tour_slug = tour.slug;
      return router.url("tours.show", params);
    }

    if (!_.isEmpty(location.region_slug)) {
        params.region_slug = location.region_slug;
        params.country_slug = location.country_slug;

        return router.url("tours.show_region", params);
    }

    if (!_.isEmpty(location.country_slug)) {
        params.country_slug = location.country_slug;

        return router.url("tours.show_country", params);
    }
}

  render() {
    const sliderSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <Arrow direction="right" />,
      prevArrow: <Arrow direction="left" />,
    };

    // console.log(this.props.data.tours);

    return (
      <div className="row">
        <div className="col">
          <ul className="nav nav-pills" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="visitors-tab"
                data-toggle="tab"
                data-target="#visitors"
                type="button"
                role="tab"
                aria-controls="visitors"
                aria-selected="true"
              >
                For Visitors
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="locals-tab"
                data-toggle="tab"
                data-target="#locals"
                type="button"
                role="tab"
                aria-controls="locals"
                aria-selected="false"
              >
                For Jamaicans
              </button>
            </li>
          </ul>

          <div className="tab-content p-0">
            <div
              className="tab-pane fade show active"
              id="visitors"
              role="tabpanel"
              aria-labelledby="visitors-tab"
            >
              <div
                className="my-5 mx-auto"
                style={{ width: "80%", maxWidth: "1000px" }}
              >
                <Slider {...sliderSettings}>
                  {this.state.visitorTours.map((tour, key) => (
                    <div className="px-1" key={key}>
                      <ExcursionItem
                        tour={tour}
                        product_url={this.generateProductUrl(tour)}
                        currency={this.props.data.env.CURRENCY}
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="locals"
              role="tabpanel"
              aria-labelledby="locals-tab"
            >
              <div
                className="my-5 mx-auto"
                style={{ width: "80%", maxWidth: "1000px" }}
              >
                <Slider {...sliderSettings}>
                  {this.state.localTours.map((tour, key) => (
                    <div className="px-1" key={key}>
                      <ExcursionItem
                        tour={tour}
                        product_url={this.generateProductUrl(tour)}
                        currency='JM'
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class Arrow extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { onClick = (f) => f, direction } = this.props;

    return (
      <button
        onClick={onClick}
        className="btn d-flex justify-content-center align-items-center"
        style={{
          position: "absolute",
          top: "40%",
          right: direction == "right" ? "-40px" : "auto",
          left: direction == "left" ? "-40px" : "auto",
          borderRadius: "50%",
          width: "35px",
          height: "35px",
          fontSize: "30px",
          color: "#2c5535",
        }}
      >
        <i
          className={`fa ${
            direction == "right" ? "fas fa-caret-right" : "fas fa-caret-left"
          }`}
        ></i>
      </button>
    );
  }
}

if (document.getElementById("excursions")) {
  const element = document.getElementById("excursions");
  const data = Object.assign({}, element.dataset);

  // console.log(data.data);

  ReactDOM.render(<App data={JSON.parse(data.data)} />, element);
}



// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/Excursions.js